/**
 *
 * Asynchronously loads the component for ResetPasswordModule
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ResetPasswordModule = lazyLoad(
  () => import('./index'),
  module => module.ResetPasswordModule,
);
